import { render, staticRenderFns } from "./plan-description.vue?vue&type=template&id=fd849a04&scoped=true&"
import script from "./plan-description.vue?vue&type=script&lang=ts&"
export * from "./plan-description.vue?vue&type=script&lang=ts&"
import style0 from "./plan-description.vue?vue&type=style&index=0&id=fd849a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd849a04",
  null
  
)

export default component.exports